import { StatusTag } from '../../../components/StatusTag';
import { useT } from '../../../locales';

interface UserStatusTagProps {
  isActive: boolean;
}

export function UserStatusTag({ isActive }: UserStatusTagProps) {
  const t = useT();
  return (
    <StatusTag tone={isActive ? 'success' : 'error'}>
      {isActive ? t('pages.users.activo') : t('pages.users.inactivo')}
    </StatusTag>
  );
}
